import { HostBinding,Component, OnInit ,ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService  } from '../../services/auth.service';
// import { EventService } from '../../services/event/event.service'; 
import { Title }     from '@angular/platform-browser';
import {Router,NavigationEnd,ActivatedRoute} from "@angular/router";
declare var $:any;

import { ToastrService } from 'ngx-toastr';
// import { MessageService } from '../../services/message.service';

import {Observable, pipe, throwError, Subscription} from 'rxjs'; 
// import { Res,IProfile } from 'src/app/entity';

import {MessageService} from '../../message.service';

import {SiteHeaderComponent} from '../../site_header/siteHeader.component';

//import { GoogleTagManagerService } from 'angular-google-tag-manager';



@Component({
  selector: 'app-layout',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './layout.component.html',
  styles: ['.left-sidebar ul li a span.nav-pending-badge{position:absolute;top:2px;left:calc(50% + 6px);display:flex;align-items:center;justify-content:center;width:18px;height:18px;min-width:18px;padding:0;margin:0;line-height:1;border-radius:50%;font-size:10px;font-weight:700;color:#fff;background:#EF3B3A;text-align:center;box-sizing:border-box;border:1.5px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,0.3);z-index:2;}']
})
export class LayoutComponent implements OnInit ,OnDestroy{
	
  profile:any ;

  url:any =[];  

  msgSubscribe:Subscription;
 
  events:any=[];

  avatar:string='';
  
  user:any;

  menus:any=[];

  router:any;

  notification:any=[];

  searchTxt:any='';

  isShow:boolean =false;

  count:any=0;

  pendingExternal:number=0;

  currentPage:any;
  

  @HostBinding('style.width') public width: string = '100%'; 



  constructor(
    private msg:MessageService,private _authService: AuthService,private titleService: Title,private _router: Router,private toastr: ToastrService) { 
  
         this.router =_router;

         this.msgSubscribe=   this.msg.getMessage().subscribe( (evt) => {

                   if(evt!=undefined){

                      
                    switch(evt.text.type){
                      
                      case 'left_menu_link':

                      this.menus = evt.text.navigations;
                      console.log('log',this.menus)
                      // this.menus.push({menu: 'GoTo', link: '/goto'})
                      

                      if(evt.text.currentPage!=undefined){
                        this.currentPage = evt.text.currentPage

                        this.msg.sendMessage({'type':'currentpage','details':this.currentPage});
                      }

                   
                       
                      this.notification = evt.text.notification;

                      // this.count = evt.text.notification.count;
                     
                      if(evt.text.user!=undefined && evt.text.user.name!=undefined){

                        this.user =evt.text.user.name ;
                         

                      }else{

                        this.user =evt.text.user ;

                      }
                      
                       
                     
                      break;

                      
                      case 'count':

                        this.notification.count = evt.text.length;
                      
                          break;

                    }

                   }


                   if(evt!=undefined && evt!=false && evt.text.type=="reset_search"){
  
                    this.searchTxt= '';
                    
          
                  }

           });



	     
  }


  moveNext(link:any){
      
    // let page = link.split('/')
     
    // this.currentPage = page[1]
   
    $('[data-toggle="popover"]').popover('hide');

    $('.tooltip-custom').tooltip("hide");   


    this.router.navigate([link]);  

  }




  ngOnInit() {

    // read pending external user count from its dedicated localStorage key
    try{
      this.pendingExternal = localStorage.getItem('pending_external') ? +localStorage.getItem('pending_external') : 0;
    }catch(e){
      this.pendingExternal = 0;
    }

    // this.router.events.forEach(item => {

    //    if (item instanceof NavigationEnd) {
 
    //       const gtmTag = {
    //         event: 'page',
    //         pageName: item.url
    //       };

    //       this.gtmService.pushTag(gtmTag);

    //     }


    //  });
    
    

    }

  ngOnDestroy() {

    this.msgSubscribe.unsubscribe();
	  

}
  
   ngAfterViewInit() {
  




   }




  /*@action : logout service   
    */
  logout() {

    var isConfirmed = confirm("Are you sure want to logout ?");
    if(isConfirmed){

      try{


        let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
    
        if(!tokenA) throw 'Error in parse';
        
        if(!JSON.parse(tokenA)) throw 'Error in json parse';
      
        tokenA = JSON.parse(tokenA);
                 
        this._authService.logout(tokenA.token).subscribe( (res) =>{
              
            if(res.status=='success'){
             
              // this.toastr.success(res.message);
              localStorage.clear();
  
              this.router.navigate(['/login']);  
            }else{
  
              this.toastr.error(res.message, '', {timeOut: 3000});
            }
            
  
            }) ;
  
      }catch(exc){
  
        localStorage.clear();
        this.toastr.error('Something went wrong', '', {timeOut: 3000});
        this.router.navigate(['/login']);  
  
      }
     
    }else{
      return false;
    }


  

  }

  
  search(){ 
    if(this.searchTxt.length > 0){

      $('#mob_menu_btn').trigger('click');

      
      this.msg.sendMessage({'type':'search','details':this.searchTxt});
      this._router.navigate(['/search']);

    }

  }

  nextP(){
   
    this._router.navigate(['/notification']);
    $('#mob_menu_btn').trigger('click');
  }

}
